import React from "react";
import CommunityFeedItem from "./CommunityFeedItem";

export default function CommunityFeed({ items }) {
  return (
    <div className="grid min-w-0 gap-4 md:grid-cols-2" data-community-feed="true">
      {items.map((item) => (
        <CommunityFeedItem key={item.id} item={item} />
      ))}
    </div>
  );
}
